<template>
  <el-dialog title="上传头像" :visible.sync="visible" :append-to-body="true" width="500px" :before-close="handleClose">
    <el-upload
      ref="uploadAvatar"
      :action="upload_url"
      list-type="picture-card"
      :http-request="UploadHttp"
      :before-upload="beforeAvatarUpload"
      :limit="1">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submitUpload">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import { uploadImage } from '@/api/user';

  export default {
    name: 'UploadAvatar',
    props: {
      visible: { type: Boolean, default: false }
    },
    data () {
      return {
        upload_url: '',
        uploadFile: null,
      };
    },
    methods: {
      handleClose () {
        this.$refs[ 'uploadAvatar' ].clearFiles();
        this.uploadFile = null;
        this.$emit('close');
      },
      UploadHttp (file) {
        this.uploadFile = file;
      },
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        } else if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      submitUpload () {
        if (this.uploadFile) {
          const file = this.uploadFile.file;
          const formData = new FormData();
          formData.append('origin', 'g12e');
          formData.append('wmType', '0');
          formData.append('files', file);
          uploadImage(formData).then(data => {
            if (data.success) {
              let path = data.result.sArray[ 0 ].url;
              this.$message({
                type: 'success',
                message: '上传头像成功',
                duration: 1500,
                onClose: () => {
                  this.$emit('uploadSuccess', path);
                  this.$refs[ 'uploadAvatar' ].clearFiles();
                }
              });

            } else {
              this.$message({
                type: 'error',
                message: data.errorMsg
              });
            }
          });
        } else {
          this.$message({
            type: 'error',
            message: '请选择上传的图片'
          });
        }

      }
    }
  };
</script>
